import React from 'react';

import { type Collectible, OrderStatus, OrderType, Side } from '@pkg/graphql/codegen/graphql';
import { useAuthentication, useNewOrder } from '@pkg/hooks';

import { useCancelOrder } from '@app/pages/ProfilePage/hooks';

import { CancelButton, ListButton } from './styles';

interface Props {
    isListed: boolean;
    item: Collectible;
}

export const ListingButton = ({ isListed, item }: Props) => {
    const { protectedAction } = useAuthentication();
    const { mutate: cancelListing } = useCancelOrder();
    const { list } = useNewOrder();

    function handleList() {
        protectedAction(() => list([item]));
    }

    //TODO: make util/helper
    const viableListing = item.orders?.find(
        (order) =>
            order.id?.startsWith('yat') &&
            order.side === Side.Ask &&
            order.type === OrderType.Limit &&
            Date.parse(order.expiresAt) > Date.now() &&
            (order.status === OrderStatus.Pending || order.status === OrderStatus.New),
    );

    function handleCancel() {
        if (viableListing?.id) {
            protectedAction(() => cancelListing({ orderItemId: viableListing.id }));
        }
    }

    const canRenderCancel = !!viableListing;
    return isListed && canRenderCancel ? (
        <CancelButton onClick={() => handleCancel()}>Cancel listing</CancelButton> // does not work right now because BE is not returning orders
    ) : (
        <ListButton onClick={handleList}>List on sale</ListButton>
    );
};
